﻿
export default class Letter {

    constructor() {
        this.gridDisplayDetail = this.gridDisplayDetail.bind(this);
        this.generateLetter = this.generateLetter.bind(this);
        this.letterContainer = null;
    }

    initialize = (options) => {
        this.letterContainer = $(options.letterContainer);
        const self = this;

        const dialogContainer = $("#letterGenDialog");
        dialogContainer.modal("show");

        $("#previewLetterButton").on("click", function (){
            self.generateLetter(false);
        });

        $("#generateLetterButton").on("click", function () {
            self.generateLetter(true);
        });

        const letterDialog = $(options.letterDialog);
        letterDialog.on('hidden.bs.modal', function () {
            self.refreshDocsOutGrid(letterDialog);
        })
    }

    refreshDocsOutGrid = (entryForm) => {
        const container = entryForm.closest(".cpiDataContainer");
        if (container) {
            const id = container.attr("id").split("-")[0];
            const grid = $(`#docsOutGrid_${id}`);
            if (grid.length > 0)
                grid.data("kendoGrid").dataSource.read();
        }
    }

    // pop-up/main screen letter generation; mass generation on setup screen is in letterSetup.js
    generateLetter(isLog) {
        const self = this;

        const letInfo = self.getSelectedLetInfo();

        if (letInfo === null) {
            const msg = this.letterContainer.data("no-letter-selected");
            cpiAlert.warning(msg);
            return;
        }

        const contactGrid = $("#contactGrid").data("kendoGrid");
        const contactData = contactGrid.dataSource.data();
        if (contactData.length === 0) {
            const msg = this.letterContainer.data("no-contacts");
            cpiAlert.warning(msg);
            return;
        }

        const selectedContacts = [];
        // don't use grid dataSource - the ClientTemplate will not be updated
        //for (let i = 0; i < contactData.length; i++) {
        //    if (contactData[i].IsGenerate) {
        //        selectedContacts.push({ EntityId: contactData[i].EntityId, ContactId: contactData[i].ContactId });
        //    }
        //}

        const checkedContacts = contactGrid.element.find(".let-generate:checked");
        checkedContacts.each(function (i, e) {
            let row = $(e).closest("tr");
            let dataItem = contactGrid.dataItem(row);
            selectedContacts.push({ EntityId: dataItem.EntityId, ContactId: dataItem.ContactId });
        });

        if (selectedContacts.length === 0) {
            const msg = this.letterContainer.data("no-selected-contacts");
            cpiAlert.warning(msg);
            return;
        }

        if (letInfo.templateFile === "") {
            const msg = this.letterContainer.data("no-template-file");
            cpiAlert.warning(msg);
            return;
        }

        const title = this.letterContainer.data("gen-title");
        let msg = "";
        if (isLog)
            msg = this.letterContainer.data("gen-log-message");
        else
            msg = this.letterContainer.data("gen-nolog-message");

        msg +=  "<br>" + "<span style='font-style:italic; font-weight: bold;' class='pt-2 pb-2'>" + letInfo.letName + "</span >";

        

        cpiConfirm.confirm(title, msg, function () {
            const data = {
                letId: letInfo.letId, isLog: isLog, systemType: letInfo.systemType, letterScreenCode: letInfo.letterScreenCode, recordId: letInfo.recordId,
                selectedContacts: selectedContacts, screenSource: "genpopup"
                //__RequestVerificationToken: $($(`input[name='${pageHelper.verificationTokenFormData}']`)[0]).val()
            };
            $("#letterFormParams").val(JSON.stringify(data));
            $("#letterForm").submit();
            //submitForm();
        });
    }

    //submitFormPromise = () => {
    //    return new Promise(resolve => $("#letterForm").submit());
    //};

    //submitForm = async () => {
    //    await submitFormPromise();
    //    console.log("after promise");
    //};

    //enableGenerateButton() {      // need to run this after completion of contact grid read
    //    const isGridEmpty = $("#contactGrid").data("kendoGrid").dataSource.data().length === 0;
    //    $("#generateLetterButton").prop('disabled', isGridEmpty);
    //    $("#previewLetterButton").prop('disabled', isGridEmpty);
    //}


    gridDisplayDetail(e) {
        if (e === null)
            return;
        const self = this;

        // add ajax to call proc_UpdatePopupFilter
        const url = this.letterContainer.data("filter-url");
        const recordKey = $("#letterRecordKey").val();
        const recordId = $("#letterRecordId").val();
        const data = $.extend({}, self.getSelectedLetId(), { recordKey: recordKey, recordId: recordId });
        
        $.ajax({
            type: "POST",
            url: url,
            headers: { "RequestVerificationToken": $($(`input[name='${pageHelper.verificationTokenFormData}']`)[0]).val() },
            data: data
        })
        .done(function () {
            self.refreshGrid("#letterFilterGrid");
            self.refreshGrid("#contactGrid");
        })
        .fail(function (e) {
            pageHelper.showErrors(e);
        });

    }

    refreshGrid (gridId) {
        const gridHandle = $(gridId);
        const grid = gridHandle.data("kendoGrid");
        grid.dataSource.read();
       
    }

    getSelectedLetId() {
        const grid = $("#letterListGrid").data("kendoGrid");
        const dataItem = grid.dataItem(grid.select());
        return { letId: dataItem.LetId };
    }

    getSelectedLetInfo() {
        const letterScreenCode = $("#letterScreenCode").val();
        const recordId = $("#letterRecordId").val();
        const grid = $("#letterListGrid").data("kendoGrid");
        if (grid.select().length === 0)
            return null;
        const dataItem = grid.dataItem(grid.select());
        return {
            letId: dataItem.LetId, letName: dataItem.LetName, templateFile: dataItem.TemplateFile,
            systemType: dataItem.SystemType, letterScreenCode: letterScreenCode, recordId: recordId
        };
    }

   
}